var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useSelector } from 'react-redux';
import { getSubmitPayload } from '../LinkApiRouter/components/TemplateForm/utils';
import { selectLinkTokenPayload } from '../state/slices/slice-link-params';
import useBankInfo from '../LinkApiRouter/hooks/useBankInfo';
export default function useUserEnteredBankInfo() {
    var linkTokenPayload = useSelector(selectLinkTokenPayload);
    var bankInfoForm = useBankInfo().bankInfoForm;
    var bankInfoPayload = getSubmitPayload(bankInfoForm);
    var userEnteredBankInfo;
    if ((linkTokenPayload === null || linkTokenPayload === void 0 ? void 0 : linkTokenPayload.enableUserInputBankInfo) && bankInfoPayload) {
        userEnteredBankInfo = __assign({ accountName: linkTokenPayload.orgName }, bankInfoPayload);
    }
    return userEnteredBankInfo;
}
